import React,{useState} from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import logocombank from '../../images/combank-logo.png'; 

export default function SucessDialog(props) {
  const [open, setOpen] = React.useState(true);
  
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    window.location.reload();
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
        <div className="logo-success"  style={{  float: "right",margin: "3px -2px 15px 0", position: "inherit" }}>
          <a href="/" title="Commercial Bank Sri Lanka" tabIndex="41"><img src={logocombank} alt="Commercial Bank Sri Lanka" title="Commercial Bank Sri Lanka"/></a>
        </div>
        
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
              Dear Sir/ Madam,
              <br/>
              <br/>
              Ref No - {props.refNo}
              <br/>
              <br/>

              We confirm that your request has been accepted. 

              You will be contacted by the Bank for further information/ communication if required.
            
              <br/>
              <br/>
              Assuring you of our best of services.
              <br/>
              <br/>
              Commercial Bank of Ceylon PLC     
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary" autoFocus>
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}